<ng-container *transloco="let t">
  <ld-base-modal [title]="address()" [size]="'large'" (closeModal)="onClose()">
    <div modal-content>
      <iframe
        id="google-maps-iframe"
        [src]="mapUrl()"
        class="w-full h-[500px]"
        frameborder="0"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        [title]="t('originationDashboardGoogleMapsIframeTitle')"
      ></iframe>
    </div>
  </ld-base-modal>
</ng-container>
